import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: "70vw",
  },
  input: {
    width: "100%",
    fontSize: theme.typography.body2.fontSize,
  },
  inputErrorMessage: {
    color: theme.palette.error.main,
  },
  disabledInputLabel: {
    color: theme.palette.grey[500],
  },
}));

export default useStyles;
